<ng-container *ngIf="versions">
  <mat-list class="versions-list">
    <mat-list-item
      *ngFor="let version of versions"
      [ngClass]="{focus: version?.id === activeVersion?.id}"
      class="mat-mdc-list-item-interactive"
      (click)="navigateToVersion(version)">
      <app-version-list-item
        [version]="version"
        [isAuthorizationActive]="isAuthorizationActive$ | async"
        [isAuthorisationInProgress]="isAuthorisationInProgress"
        *q9Screenshot="version | transform: getConfigForScreen.bind(this)"
        (makeReady)="onMakeReadyForRelease()"
        (turnReadyAuthorization)="onTurnOnReadyAuthorization($event)"
        (submitForAuthorization)="openSubmitForAuthorizationPopup()"></app-version-list-item>
    </mat-list-item>
  </mat-list>
</ng-container>
